import { AbstractControl, ValidatorFn } from '@angular/forms';

export function valueInListValidator(validValues: any[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!control.value) {
      return null;
    }
    const value = control.value;
    if (validValues.includes(value)) {
      return null;
    } else {
      return { valueNotInList: true };
    }
  };
}
